"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadlineDescriptor = void 0;
var PluggableHeadline_1 = require("./PluggableHeadline");
var constants_1 = require("../constants");
var hasSecondaryMeasure = function (insight) {
    return insight.insight.buckets.filter(function (bucket) { return bucket.items.length > 0; }).length > 1;
};
var HeadlineDescriptor = /** @class */ (function () {
    function HeadlineDescriptor() {
    }
    HeadlineDescriptor.prototype.getFactory = function () {
        return function (params) { return new PluggableHeadline_1.PluggableHeadline(params); };
    };
    HeadlineDescriptor.prototype.getSizeInfo = function (insight, layoutDescriptor, settings) {
        return {
            width: {
                default: 2,
                min: 2,
                max: layoutDescriptor.gridColumnsCount,
            },
            height: {
                default: this.getDefaultHeight(insight, settings.enableKDWidgetCustomHeight),
                min: this.getMinHeight(insight, settings.enableKDWidgetCustomHeight),
                max: this.getMaxHeight(insight, settings.enableKDWidgetCustomHeight),
            },
        };
    };
    HeadlineDescriptor.prototype.getDefaultHeight = function (insight, enableCustomHeight) {
        if (!enableCustomHeight) {
            return constants_1.DASHBOARD_LAYOUT_DEFAULT_KPI_HEIGHT;
        }
        return hasSecondaryMeasure(insight) ? 11 : 8;
    };
    HeadlineDescriptor.prototype.getMinHeight = function (insight, enableCustomHeight) {
        if (!enableCustomHeight) {
            return constants_1.DASHBOARD_LAYOUT_DEFAULT_KPI_HEIGHT;
        }
        return hasSecondaryMeasure(insight) ? 10 : 6;
    };
    HeadlineDescriptor.prototype.getMaxHeight = function (_insight, enableCustomHeight) {
        if (!enableCustomHeight) {
            return constants_1.DASHBOARD_LAYOUT_DEFAULT_KPI_HEIGHT;
        }
        return constants_1.MAX_VISUALIZATION_HEIGHT;
    };
    HeadlineDescriptor.prototype.applyDrillDown = function (insight) {
        return insight;
    };
    return HeadlineDescriptor;
}());
exports.HeadlineDescriptor = HeadlineDescriptor;
//# sourceMappingURL=HeadlineDescriptor.js.map